/**
 * Sell Ready — podcast archive (Episodes list) search + tag filter.
 * Instant client-side filter over title/guest text and tag pills, with
 * a "load more" reveal so the full archive isn't dumped into view at
 * once. Reads ?topic=<tag> on load to pre-select a tag (used when
 * linking here from an episode page's Topics list) and keeps the URL
 * in sync as the active tag changes, so filtered views are shareable.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var tagBar = document.querySelector('[data-episode-tag-pills]');
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-episode-card]'));
    if (!tagBar || !cards.length) return;

    var searchInput = document.querySelector('[data-episode-search]');
    var loadMoreBtn = document.querySelector('[data-episode-load-more]');
    var noResultsEl = document.querySelector('[data-episode-no-results]');
    var filterToggle = document.querySelector('[data-episode-filter-toggle]');
    var pills = Array.prototype.slice.call(tagBar.querySelectorAll('[data-tag]'));

    var PAGE_SIZE = 6;
    var visibleCount = PAGE_SIZE;
    var activeTag = 'all';

    var params = new URLSearchParams(window.location.search);
    var topicParam = params.get('topic');
    var landedOnTopic = false;
    if (topicParam && pills.some(function (p) { return p.getAttribute('data-tag') === topicParam; })) {
      activeTag = topicParam;
      landedOnTopic = true;
    }

    function matches(card) {
      var tagOk = activeTag === 'all' || (card.getAttribute('data-tags') || '').split(',').indexOf(activeTag) !== -1;
      if (!tagOk) return false;

      var query = ((searchInput && searchInput.value) || '').trim().toLowerCase();
      if (!query) return true;

      var haystack = (card.getAttribute('data-title') || '') + ' ' + (card.getAttribute('data-guest') || '');
      return haystack.toLowerCase().indexOf(query) !== -1;
    }

    function render() {
      var matchCount = 0;
      cards.forEach(function (card) {
        if (matches(card)) {
          card.hidden = matchCount >= visibleCount;
          matchCount++;
        } else {
          card.hidden = true;
        }
      });

      if (loadMoreBtn) loadMoreBtn.hidden = matchCount <= visibleCount;
      if (noResultsEl) noResultsEl.hidden = matchCount > 0;
    }

    function syncActivePill() {
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tag') === activeTag);
      });
      if (filterToggle) {
        var activePill = pills.filter(function (p) { return p.getAttribute('data-tag') === activeTag; })[0];
        var label = activeTag !== 'all' && activePill ? activePill.textContent : 'Filter';
        filterToggle.lastChild.textContent = ' ' + label;
        filterToggle.classList.toggle('is-active', activeTag !== 'all');
      }
    }

    function setFilterOpen(open) {
      tagBar.classList.toggle('is-open', open);
      if (filterToggle) filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function updateUrl() {
      var url = new URL(window.location.href);
      if (activeTag === 'all') {
        url.searchParams.delete('topic');
      } else {
        url.searchParams.set('topic', activeTag);
      }
      window.history.replaceState({}, '', url);
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tag = pill.getAttribute('data-tag');
        activeTag = (activeTag === tag && tag !== 'all') ? 'all' : tag;
        visibleCount = PAGE_SIZE;
        syncActivePill();
        updateUrl();
        render();
        setFilterOpen(false);
      });
    });

    if (filterToggle) {
      filterToggle.addEventListener('click', function () {
        setFilterOpen(!tagBar.classList.contains('is-open'));
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        visibleCount = PAGE_SIZE;
        render();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += PAGE_SIZE;
        render();
      });
    }

    syncActivePill();
    render();

    if (landedOnTopic) {
      setFilterOpen(true);
      tagBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
